import { render, staticRenderFns } from "./ExportExcelKidPackageOrderKids.vue?vue&type=template&id=3877b450&scoped=true"
import script from "./ExportExcelKidPackageOrderKids.vue?vue&type=script&lang=js"
export * from "./ExportExcelKidPackageOrderKids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877b450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3877b450')) {
      api.createRecord('3877b450', component.options)
    } else {
      api.reload('3877b450', component.options)
    }
    module.hot.accept("./ExportExcelKidPackageOrderKids.vue?vue&type=template&id=3877b450&scoped=true", function () {
      api.rerender('3877b450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/ExportExcelKidPackageOrderKids.vue"
export default component.exports